import { ButtonHTMLAttributes, ReactNode } from 'react';
import Spinner from './Spinner';

type Variant = 'primary' | 'secondary' | 'danger';

interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: Variant;
  loading?: boolean;
  children: ReactNode;
}

const variantClasses: Record<Variant, string> = {
  primary:
    'bg-brand-500 text-white hover:bg-brand-600 focus-visible:outline-brand-500 disabled:bg-brand-200',
  secondary:
    'bg-white text-ink border border-ink-light hover:bg-brand-50 hover:border-brand-500 hover:text-brand-600 focus-visible:outline-brand-500 disabled:text-ink-muted',
  danger:
    'bg-danger-500 text-white hover:bg-danger-600 focus-visible:outline-danger-500 disabled:bg-danger-50 disabled:text-danger-500',
};

const Button = ({
  variant = 'primary',
  loading = false,
  disabled,
  children,
  className,
  type,
  ...rest
}: ButtonProps) => {
  const isDisabled = disabled || loading;
  const variantCls = variantClasses[variant];
  return (
    <button
      type={type ?? 'button'}
      disabled={isDisabled}
      className={[
        'inline-flex items-center justify-center gap-2 rounded-md px-4 py-2.5 text-sm font-medium',
        'shadow-sm transition focus:outline-none focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2',
        'disabled:cursor-not-allowed',
        variantCls,
        className ?? '',
      ].join(' ')}
      {...rest}
    >
      {loading ? <Spinner size="sm" /> : null}
      <span>{children}</span>
    </button>
  );
};

export default Button;
